import { Legends } from "app/components/React/Legends/Legends";
import type { ILegendItem } from "app/components/React/Legends/legendsTypes";

type AgeDistributionComparisonChartLegendsProps = {
    legendItems: ILegendItem[];
    onToggleLegendItem: (item: ILegendItem) => void;
};

export const AgeDistributionComparisonChartLegends = ({
    legendItems,
    onToggleLegendItem,
}: AgeDistributionComparisonChartLegendsProps) => (
    <Legends
        legendItems={legendItems}
        toggleSeries={onToggleLegendItem}
    />
);
